import React, { ComponentProps, FC } from 'react';

import { compose, composeU } from '@yandex-int/hr-components/lib/compose';
import { Registry, withRegistry } from '@bem-react/di';
import { Icon as BaseIcon, IIconProps } from '@yandex-int/hr-components/Icon';
import {
    cnSelect,
    withBaseline,
    withWidthMax,
} from '@yandex-int/hr-components/Select';
import {
    Select as BaseSelect,
} from '@yandex-int/hr-components/Select/bundle';
import { withArrowShortDownIcon } from "@yandex-int/hr-components/Icon/_glyph/ArrowShortDown";
import {
    withViewContrast,
    withViewGhost,
    withViewSecondary
} from "@yandex-int/hr-components/Button";
import { withSizeL, withSizeS } from "@yandex-int/hr-components/Button";
import { Menu } from "@yandex-int/hr-components/Menu/bundle";
import { Button } from "../button/button";
import { ILegalSelectProps, withViewLegal } from "./Select_view_legal";


const Icon = composeU(withArrowShortDownIcon)(BaseIcon);

export const IconForSelect = (props: IIconProps) => (
    <Icon
        {...props}
        className={cnSelect('Icon', [props.className])}
        sizeManagement="parent"
    />
);

const SelectWithView: FC<ILegalSelectProps> = (props) => {
    return (<BaseSelect
            {...props}
            // Леговскому селекту нельзя назначить никакой другой view
            view="outline"
            contentEditable="inherit"
        />
    );
};

const ComposedSelect = compose(
    withBaseline,
    withWidthMax,
    composeU(
        withViewGhost,
        withViewContrast,
        withViewSecondary,
        withViewLegal
    ),
    composeU(withSizeL, withSizeS),
)(SelectWithView);

export type SelectProps = ComponentProps<typeof Select>;

const registry = new Registry({ id: cnSelect() })
    .set('Trigger', Button)
    .set('Icon', IconForSelect)
    .set('Menu', Menu);

export const Select = withRegistry(registry)(ComposedSelect);
